module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Price #1-a2522e4c90f91dc834fa60353ca97a48.svg";